import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import ReactTost from "../../ReactTost";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader";

const DeletePlan = (props) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
 
  const [showAlert, setShowAlert] = useState(false);

  function DeletePlans(id) {
      console.log("Plan id :",id);
      axios
        .delete(`${API_URL}/${API_VERSION}/plan/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          props.getplans();
          setLoading(false);
          setType("Success");
          setMessage(t("You plan is deleted"));
          setShowAlert(true);
          props.onHide();
        
          setTimeout(() => {
            navigate(`/admin/plans-list`);
          }, 3000);
        

        })
        .catch((error) => {
          setLoading(false);
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  
  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      {loading ? (
        <Loader />
      ) : (
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
            {t("Delete plan")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p> {t("Are you sure you want to delete your plan? This action cannot be undone.")} </p>
            <div className="form-group">
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="button" onClick={props.onHide}>{t("Cancel")}</button>
            <button className="button color_orange" onClick={() => {DeletePlans(props.getPlanId); }}> {t("Delete")}</button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default DeletePlan;
